import appConfig from '../config';
import { SECURITY_REPORT_PATH } from './paths';

export const SECURITY_REPORT_PAGE_URL = `${appConfig.secureOrigin}${SECURITY_REPORT_PATH}`;
export const BUGCROWD_PROGRAM_URL =
  'https://bugcrowd.com/2860eebf-a79d-4862-9fa4-4d683c9e05e7/external';
